var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAreachart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "areachart-outlined") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-215.000000, -306.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "areachart-outlined",
    transform: "translate(215.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125,18.5625 L4.6875,18.5625 L4.6875,3.9375 C4.6875,3.834375 4.603125,3.75 4.5,3.75 L3.1875,3.75 C3.084375,3.75 3,3.834375 3,3.9375 L3,20.0625 C3,20.165625 3.084375,20.25 3.1875,20.25 L20.8125,20.25 C20.915625,20.25 21,20.165625 21,20.0625 L21,18.75 C21,18.646875 20.915625,18.5625 20.8125,18.5625 Z M6.375,17.0625 L18.9375,17.0625 C19.040625,17.0625 19.125,16.978125 19.125,16.875 L19.125,6.65625 C19.125,6.4875 18.9210937,6.40546875 18.8039062,6.52265625 L13.875,11.4515625 L10.9359375,8.5453125 C10.8632812,8.47265625 10.74375,8.47265625 10.6710938,8.5453125 L6.24140625,12.9890625 C6.20625,13.0242188 6.1875,13.0710938 6.1875,13.1203125 L6.1875,16.875 C6.1875,16.978125 6.271875,17.0625 6.375,17.0625 Z",
    id: "\\u5F62\\u72B6"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreachart);
export default __webpack_public_path__ + "static/media/areachart.dd139567907104afca5939952b924b86.svg";
export { ForwardRef as ReactComponent };